import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tile-vertical',
  templateUrl: './tile-vertical.component.html',
  styleUrls: ['./tile-vertical.component.scss'],
  standalone: false,
})
export class TileVerticalComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() link: string = '';
  @Input() mediaUrl: string = '';
  @Input() mediaType: 'image' | 'video' | 'default' = 'default';
  @Input() embedUrl?: string;

  constructor() {}
}
